import React, { FC } from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { ConnectionType } from './types';

interface SelectConnectionTypeProps {
  value: ConnectionType;
  onChange: (value: ConnectionType) => void;
}

export const SelectConnectionType: FC<SelectConnectionTypeProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div style={{ marginBottom: 8 }}>{t('system.connectors.fields.connectionType') || "Тип з'єднання"}</div>

      <Select<ConnectionType>
        value={value}
        style={{ width: '100%' }}
        onChange={onChange}
        options={[
          { value: 'PUSH', label: 'PUSH' },
          { value: 'PULL', label: 'PULL' },
        ]}
      />
    </div>
  );
};
